/**
 * CONSAI Business App - Plan Expired Modal Component
 * Shows when user's plan has expired and they try to perform actions
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from '../components/ui/button';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from '../components/ui/dialog';
import { AlertTriangle, Crown } from 'lucide-react';

const PlanExpiredModal = ({ open, onClose }) => {
  const { language } = useLanguage();
  const navigate = useNavigate();

  const handleChoosePlan = () => {
    onClose();
    navigate('/plans');
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center justify-center mb-4">
            <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center">
              <AlertTriangle className="h-8 w-8 text-amber-600" />
            </div>
          </div>
          <DialogTitle className="text-center font-manrope text-xl">
            {language === 'hi' ? 'आपका प्लान समाप्त हो गया' : 'Your Plan Has Expired'}
          </DialogTitle>
          <DialogDescription className="text-center text-slate-600">
            {language === 'hi' 
              ? 'जारी रखने के लिए कृपया एक प्लान चुनें।' 
              : 'Please choose a plan to continue using all features.'}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col gap-2 sm:flex-col">
          <Button 
            onClick={handleChoosePlan} 
            className="w-full bg-[#021945] hover:bg-[#021945]/90"
            data-testid="choose-plan-btn"
          >
            <Crown className="h-4 w-4 mr-2" />
            {language === 'hi' ? 'प्लान चुनें' : 'Choose a Plan'}
          </Button>
          <Button 
            variant="outline" 
            onClick={onClose} 
            className="w-full"
          >
            {language === 'hi' ? 'बाद में' : 'Maybe Later'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PlanExpiredModal;
